import React from "react";
import LoadingImg from "../../../images/animacion2[18].gif";

/*
.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 150;
    background-color: #FFFFFFA0;
    text-align: center;
}

.overlay-fullScreen {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2000;
    overflow: none;
    background-color: rgb(255, 255, 255);
    text-align: center;
}
*/

const LoadingPlan = () =>
  (<div
    className="overlay"
    style={{ position: "fixed", zIndex: 2000 }}
    tabIndex={-1}
    role="dialog"
    aria-labelledby="loadingPagesTitle"
    data-backdrop="static"
  >
    <div className="overlay-content">
      <div>
        <img draggable={false} src={LoadingImg} alt="Cargando" />
      </div>
    </div>
  </div>);

export default LoadingPlan;
